import React, { useState, memo, forwardRef } from 'react';
import EyeOpened from '../../../assets/img/Eye opened.png';
import EyeClosed from '../../../assets/img/Eye Closed.png';

const MInput = forwardRef(({
                    placeholder,
                    value,
                    setValue,
                    type = 'text',
                    error = null,
                    name,
                    disabled = false,
                    readOnly = false,
                    maxLength = 2000,
                    ...props
}, ref) => {
    const [isPasswordShown, setIsPasswordShown] = useState(false);
    return (
      <>
          {type === 'password' ? (
            <div className={'relative'}>
                <input
                  {...props}
                  ref={ref}
                  type={isPasswordShown ? 'text' : 'password'}
                  placeholder={placeholder}
                  value={value}
                  name={name}
                  onChange={setValue}
                  readOnly={readOnly}
                  maxLength={maxLength}
                  disabled={disabled}
                  className={`p-3 border w-full pr-11 border-gray-400 rounded-xl m-1 ${error && 'border-2 border-red-700'} ${props.className}`}
                />

                <img
                  className={'absolute right-4 top-[50%] translate-y-[-50%] cursor-pointer'}
                  src={isPasswordShown ? EyeOpened : EyeClosed}
                  alt='see password'
                  onClick={() => setIsPasswordShown(prev => !prev)}
                />
            </div>
          ) : (
            <input
              {...props}
              ref={ref}
              type={type}
              placeholder={placeholder}
              value={value}
              name={name}
              disabled={disabled}
              readOnly={readOnly}
              maxLength={maxLength}
              onChange={setValue}
              className={`p-3 border border-gray-400 w-full rounded-xl m-1 ${error && 'border-2 border-red-700'} ${props.className}`}
            />
          )}
      </>
    );
});

export default memo(MInput);